import styled from '@emotion/styled';
import {
  description,
  detail,
  error,
  title,
  titleSecondary,
} from 'styles/text';

export const Detail = styled.span`
  ${detail};
`;

export const Description = styled.span`
  ${description};
`;

export const Error = styled.span`
  ${error};
`;

export const Title = styled.span`
  ${title};
`;

export const TitleSecondary = styled.span`
  ${titleSecondary};
`;
